import type { CodeableConcept } from '@medplum/fhirtypes'
import { addBusinessDays } from 'date-fns'
import type { Order } from '#src/models/orders/index.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import {
  StandardTask,
  type StandardTaskParams,
} from '#src/models/tasks/standard/standardTask.ts'
import { ROLES, Role } from '#src/roles.ts'
import { now, recordKeys } from '#src/utils.ts'

export class DocumentHomeCareOrderScheduleTask extends StandardTask {
  static defaultRoles = recordKeys(ROLES).filter((r) => r !== Role.PCP)

  constructor({
    order,
    ...rest
  }: StandardTaskParams & {
    order: Order
  }) {
    super({
      code: DocumentHomeCareOrderScheduleTask.code,
      priority: 'routine',
      focus: order.reference,
      requester: order.signedBy,
      owner: order.requester,
      ...rest,
    })
    this.title = 'Document Home Care Order Schedule'
    this.description = 'Document the home care order schedule'
    this.state = 'todo'
    this.participant = order.participant
    this.dueOn = addBusinessDays(now(), 5).toISOString()
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.DOCUMENT_HOME_CARE_ORDER_SCHEDULE
  }
}
